module.exports = __webpack_public_path__ + "media/images/exp-thumb-lg-ae10d71385308d18fef22b45e87d1f63.png";